// extracted by mini-css-extract-plugin
export default {"navigationContainer":"StepNavigation_navigationContainer__O6K4h","leftActions":"StepNavigation_leftActions__P1FKJ"};